/**
 * @ngdoc services
 * @memberof mercury.modules.settings
 * @name Company
 * @description Service for managing Company location settings, and tax rates
 */
angular.module('mercury.modules.settings.company')
.factory('CompanyLocale', ["userinfo", function(userinfo) {

  // Returns a list of supported countries
  function countries() {
    return [
      {code: 'NZ', label: 'New Zealand'},
      {code: 'AU', label: 'Australia'}
    ];
  }

  function provinces(countryCode) {
    switch (countryCode) {
      case 'NZ':
        return null;
      case 'AU':
        return [
          {code: 'ACT', label: 'Australian Capital Territory'},
          {code: 'NSW', label: 'New South Wales'},
          {code: 'NT', label: 'Northern Territory'},
          {code: 'QLD', label: 'Queensland'},
          {code: 'SA', label: 'South Australia'},
          {code: 'TAS', label: 'Tasmania'},
          {code: 'VIC', label: 'Victoria'},
          {code: 'WA', label: 'Western Australia'}
        ];
    }
  }

  function timezones() {
    var codes = moment.tz.names();

    var timezones = [];
    var topTimezones = [];

    var isTopTimezone = function(zoneName) {
      return zoneName.startsWith('Australia/') || zoneName === 'Pacific/Auckland';
    };

    for (var i = 0; i < codes.length; i++) {
      var zone = {code: codes[i], label: codes[i].replaceAll('_', ' ')};
      if (isTopTimezone(codes[i])) {
        topTimezones.push(zone);
      } else {
        timezones.push(zone);
      }
    }

    //Put Aus countries at the top of the list
    for (i = topTimezones.length - 2; i >= 0; i--) {
      timezones.unshift(topTimezones[i]);
    }

    //Finally, put NZ at the very top of the list
    timezones.unshift(topTimezones[topTimezones.length - 1]);

    return timezones;
  }

  function getCountryCode(companyId) {
    var locale = userinfo.companyPreferenceGet('locale.locale', companyId);
    return locale.split('-')[1];
  }

  function getLanguageCode(companyId) {
    var locale = userinfo.companyPreferenceGet('locale.locale', companyId);
    return locale.split('-')[0];
  }

  function setCountryCode(companyId, countryCode) {
    var languageCode = getLanguageCode(companyId);
    var localeCode = languageCode + '-' + countryCode;
    userinfo.companyPreferenceSet({key: 'locale.locale', value: localeCode}, companyId);
  }

  function setLanguageCode(companyId, languageCode) {
    var countryCode = getCountryCode(companyId);
    var localeCode = languageCode + '-' + countryCode;
    userinfo.companyPreferenceSet({key: 'locale.locale', value: localeCode}, companyId);
  }

  function getLocaleCode(companyId) {
    return userinfo.companyPreferenceGet('locale.locale', companyId);
  }

  return {
    countries: countries,
    provinces: provinces,
    timezones: timezones,
    getCountryCode: getCountryCode,
    setCountryCode: setCountryCode,
    getLanguageCode: getLanguageCode,
    setLanguageCode: setLanguageCode,
    getLocaleCode: getLocaleCode
  };
}]);
